import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { LocationMediaEnum } from './LocationMedia'

export const StyledImages = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  ${({ $variant }) => {
    if ($variant === 1) {
      return `
      justify-content: center`
    }
    if ($variant === 2) {
      return `
      justify-content: space-around
      `
    }
  }}
`

export const StyledMedia = styled.div`
  border-radius: ${pxToRem(5)};
  position: relative;
  overflow: hidden;
  width: 100%;
  img,
  video,
  iframe {
    width: 100%;
    height: 100%;
    border-radius: ${pxToRem(5)};
  }

  ${({ $variant, $position }) => {
    if ($variant === LocationMediaEnum[2]) {
      return `
      max-width: ${pxToRem(363)};
    height: ${pxToRem(232)};
    border-radius: ${pxToRem(5)};
    margin: 0 ${pxToRem(10)};`
    }
    if ($variant === LocationMediaEnum[3]) {
      if ($position === 0) {
        return `  
        max-width: ${pxToRem(521)};
    max-height: ${pxToRem(282)};
    margin: 0 ${pxToRem(20)} ${pxToRem(20)} 0;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)};
    video,
    img,
    iframe {
      border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)};
    }
`
      } else
        return `
    max-width: ${pxToRem(245)};
    max-height: ${pxToRem(131)};
    border-radius: ${pxToRem(5)};
    margin-bottom: ${pxToRem(20)};
`
    }
  }}
`

export const StyledMediaCaption = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  bottom: 0;
  height: ${pxToRem(50)} !important;
  background-color: ${({ theme }) => theme.colors.unique.black};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  font-size: ${({ theme }) => theme.fonts.sizes.md};
  line-height: ${({ theme }) => theme.fonts.lineHeight.md};
  color: ${({ theme }) => theme.colors.unique.white};
  padding: 0 ${pxToRem(5)} 0 ${pxToRem(8)};
  border-radius: 0 0 ${pxToRem(5)} ${pxToRem(5)};
  ${({ $variant, $position }) => {
    if ($variant === LocationMediaEnum[3] && $position === 0) {
      return `  padding: 0 ${pxToRem(10)} 0 ${pxToRem(18)};
      border-radius: 0 0 ${pxToRem(5)} ${pxToRem(30)};`
    }
  }}
`

export const StyledSide = styled.div``
